"use client";
// Imports
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import Link from "next/link";
import { Placeholder, Img, Content, AddToMyShowButton } from "@/components";
import { X } from "lucide-react";
import { DrawerClose } from "@/components/ui/drawer";
export function FoodFinderDetails({
  data,
  userId,
  type,
  foodType,
  title,
  categories,
  locations,
  showAddToMyShow,
  image,
  mapIsActive,
}) {
  return (
    <div
      className="grid lg:h-full h-[90dvh] max-h-[90dvh] overflow-y-auto grid-cols-1 lg:overflow-hidden lg:grid-cols-2"
      style={{
        // Red gum accents instead of theme saddle orange
        "--button-background": "137 33 2",
        "--button-hover-background": "137 33 2",
        "--button-foreground": "255 255 255",
      }}
    >
      <div className="order-last col-span-1 w-full h-full rounded-l-lg text-foregorund lg:order-first bg-background">
        <div className="flex flex-col justify-between p-4 space-y-6 h-full lg:p-8">
          <div className="pr-2 space-y-5">
            <div className="flex justify-between space-x-5 w-full">
              <h2 className="flex justify-between items-center space-x-2 level-2">
                <span>{title}</span>
              </h2>
              <div className="flex justify-end">
                {showAddToMyShow && (
                  <AddToMyShowButton
                    userId={userId}
                    type={type}
                    slug={data.slug}
                    image={image}
                    title={title}
                  />
                )}
              </div>
            </div>

            {categories?.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {categories?.map((category, index) => (
                  <Label dark={false} key={index}>
                    {category?.title}
                  </Label>
                ))}
              </div>
            )}
            <div className="overflow-y-auto text-sm">
              <div className="space-y-3">
                <Content content={data?.content} />
              </div>
            </div>
          </div>
          {locations?.length > 0 && mapIsActive && (
            <div className="space-y-3">
              <div className="flex justify-between items-end">
                <div>
                  <p className="pb-2">Where to find</p>
                  <div className="flex overflow-y-hidden justify-between items-center w-full">
                    <div className="flex flex-wrap gap-2 justify-start w-full">
                      {locations.map((location, index) => (
                        <Button size="xs" key={index} variant="outline">
                          <Link href={`/map?pin=${location?.slug}`}>
                            {location?.title}
                          </Link>
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="relative col-span-1 w-full h-full">
        <div className="h-[300px] lg:h-full aspect-auto overflow-hidden relative rounded-t-lg lg:rounded-none">
          <DrawerClose asChild>
            <div className="flex absolute top-2 right-2 z-50 justify-center items-center w-8 h-8 rounded-full cursor-pointer lg:hidden bg-foreground text-background">
              <X />
            </div>
          </DrawerClose>
          {image ? (
            <Img fill className={""} data={image} sizes="(max-width: 1024px) 100vw, 500px" />
          ) : (
            <Placeholder type="image-placeholder" />
          )}
        </div>
      </div>
    </div>
  );
}
